import React from 'react';
import { NavLink } from 'react-router-dom';

type NavLinkItem = {
  label: string;
  to: string;
};

type LayoutNavProps = {
  navLinks: NavLinkItem[];
};

const LayoutNav: React.FC<LayoutNavProps> = ({ navLinks }) => (
  <nav className="w-full relative before:absolute before:w-full before:h-0.5 before:bg-border before:bottom-0">
    <ul className="max-w-full overflow-x-auto hide-scroller flex items-end gap-4">
      {navLinks.map((link) => (
        <li key={link.to} className="contents">
          <NavLink
            to={link.to}
            className={`py-2 px-0 text-nowrap border-b-2 relative z-[2] font-medium settings-nav-link`}
          >
            {link.label}
          </NavLink>
        </li>
      ))}
    </ul>
  </nav>
);

export default LayoutNav;
